import Section from './_Section'
import { createMarkup } from '../../helpers/markup'
import ButtonEl from '../helpers/ctas/Button'
import { transformPaddingToTailwind } from '../../helpers/style'

function BasicContent(props) {
  const componentPadding = transformPaddingToTailwind(props.componentPadding)

  return (
    <Section type="basicContent" outerClass={componentPadding} innerClass="px-7" {...props}>
      {props.ctaLink?.length != 0 && (
        <div className={`flex justify-${props.ctaLinkAlignment !== 'Center' ? 'start' : 'center'} space-x-6 mt-10`}>
          {props.ctaLink.map((ctaLinkItem, i) => (
            <ButtonEl
              key={i}
              link={ctaLinkItem.link}
              theme={ctaLinkItem.linkType.toLowerCase()}
              icon={ctaLinkItem.linkIconClass}
            />
          ))}
        </div>
      )}
    </Section>
  )
}

export default BasicContent
